import { lazy } from 'react';
import Hero from '../components/Hero';

const About = lazy(() => import('../components/About'));
const Contact = lazy(() => import('../components/Contact'));
const Experience = lazy(() => import('../components/Experience'));
const Projects = lazy(() => import('../components/Projects'));
const Skills = lazy(() => import('../components/Skills'));

export const sectionRegistry = {
  hero: Hero,
  about: About,
  projects: Projects,
  skills: Skills,
  experience: Experience,
  contact: Contact,
};
